<template>
<div>
<input type="text" class="quickInput"/>

<table class="ElementSummary">
    <tr>
        <td>
            {{this.elements.length}} items
        </td>
        <td colspan="2">
            <input type="text" v-model="search" placeholder="Search..." class="quick-input" style="width:200px" />
        </td>
    </tr>
    <tr v-for="element in elements" :key="element.key" @click.stop="log(element)">
        <td><span :title="element.name">{{element.title || element.key}}</span></td>
        <td><span>{{element.name}}</span></td>
        <td><div class="truncate">{{element.value}}</div></td>
    </tr>
</table>
  
</div>
</template>

<script>

import StringHelpers from '../helpers/StringHelpers'
import OrderHelpers from '../helpers/OrderHelpers'
import DataHelpers from '../helpers/DataHelpers'
import ElementHelpers from '../helpers/ElementHelpers'


export default {
    data() {
        return {
            comment: '',
            search: '',
        }
    },
    
    props: {
       
    },

    computed: {
        elements() {
            let elementsList = ElementHelpers.getElements().map(o => {
                let obj = {...o}
                obj.order = obj.title || obj.name || 'aaa'
                return obj
            }).sort(OrderHelpers.sortAscending )

            if(this.search) {
                
                elementsList = elementsList.filter(
                    o => o.name && o.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || 
                            o.title && o.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1 
                )

            }
  
            
            return elementsList
        }
    },

    methods: {
        log(element) {
            console.log(element)
            let path = DataHelpers.getTransactionRef().toString() + `/elements/${element.key}`
            console.log('Path:', path)
        }
    }
}
</script>

<style scoped>

tr {border-bottom: solid 1px #ccc; color: grey}
td {border-bottom: solid 1px #ccc; padding:9px 6px;}
 
</style>




// WEBPACK FOOTER //
// ElementSummary.vue?3e076a55